import {
  CalendarTask,
  CalendarTaskHeaderGroup,
  CalendarTasksGroup,
  CommonUtils,
} from '@infodata-group/inf-commons';
import { Dayjs } from 'dayjs';

export class CalendarSection {
  section1: CalendarTask[] = [];
  section2: CalendarTask[] = [];

  public startMorning: Dayjs;
  public endMorning: Dayjs;
  public startAfternoon: Dayjs;
  public endAfternoon: Dayjs;

  public isTeleworked = false;
  public isOff = false;

  public teleworkColor: string;
  public dayOffColor: string;

  get backgroundColor(): string {
    if (this.isOff) {
      return this.dayOffColor;
    }
    if (this.isTeleworked) {
      return this.teleworkColor;
    }
    return CommonUtils.color('white');
  }

  constructor(
    public nbSection: 1 | 2,
    public group: CalendarTaskHeaderGroup,
    public resource: CalendarTasksGroup,
  ) {}
}
